/* eslint-disable no-mixed-spaces-and-tabs,no-param-reassign,no-tabs,@typescript-eslint/no-unused-vars,radix */

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerDatabaseSourceComponent', [
    'DesignerDatabaseBaseSourceComponent',

    function (DesignerDatabaseBaseSourceComponent) {
      function DesignerDatabaseSourceComponent() {
        DesignerDatabaseBaseSourceComponent.apply(this);

        this.split_by_column_name = null;
        this.parallel = null;
        this.before_action = null;
      }

      DesignerDatabaseSourceComponent.prototype = new DesignerDatabaseBaseSourceComponent();

      DesignerDatabaseSourceComponent.prototype.getData = function () {
        const data = DesignerDatabaseBaseSourceComponent.prototype.getData.call(this);

        _.extend(data, {
          split_by_column_name: this.split_by_column_name || '',
          parallel: this.parallel || 1,
          before_action: this.before_action || 'none',
        });

        return data;
      };

      DesignerDatabaseSourceComponent.prototype.getFormData = function () {
        const data = DesignerDatabaseBaseSourceComponent.prototype.getFormData.call(this);

        return data;
      };

      DesignerDatabaseSourceComponent.prototype.setFormData = function (data) {
        if (data.access_mode === 'table') {
          if (data.split_by_column_name.length === 0) data.parallel = 1;
        } else if (data.access_mode === 'query') {
          data.split_by_column_name = '';
          data.parallel = '';
        }

        this.setData(data);

        DesignerDatabaseBaseSourceComponent.prototype.setFormData.call(this, data);
      };

      DesignerDatabaseSourceComponent.prototype.setData = function (data) {
        if (typeof data.parallel === 'string') data.parallel = parseInt(data.parallel);

        this.before_action = data.before_action;
        this.parallel = data.parallel;
        this.split_by_column_name = data.split_by_column_name;

        DesignerDatabaseBaseSourceComponent.prototype.setData.call(this, data);
      };

      DesignerDatabaseSourceComponent.prototype.getSchema = function () {
        const schema = DesignerDatabaseBaseSourceComponent.prototype.getSchema.call(this);

        return schema;
      };

      return DesignerDatabaseSourceComponent;
    },
  ]);
})(window.angular);
